import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MarketsTableComponent } from './components';
import makeMergeData from './selector';

const MarketsTable = props => (
  <MarketsTableComponent search={props.filter} snapshots={props.results} />
);

function mapStateToProps(state) {
  return {
    results: makeMergeData(state),
  };
}

MarketsTable.defaultProps = {
  filter: '',
};

MarketsTable.propTypes = {
  filter: PropTypes.string.isRequired,
  results: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(MarketsTable);



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsTable/index.jsx